/**
 * A frame-rate readout for trying the game on a phone (dev mode, `?fps=1`): the frames a second over the last half
 * second and its longest frame, in a corner over the game. A DOM element on the page's own frames, so it costs the
 * canvas nothing and measures what the player sees.
 */
export function installFpsMeter(search: string): void {
  if (new URLSearchParams(search).get("fps") !== "1") return;
  const box = document.createElement("div");
  box.style.cssText =
    "position:fixed;left:6px;top:6px;z-index:2147483647;padding:2px 6px;border-radius:4px;background:rgba(0,0,0,0.65);color:#4f4;font:12px/1.4 monospace;pointer-events:none";
  document.body.appendChild(box);
  let frames = 0;
  let longest = 0;
  let last = performance.now();
  let since = last;
  const frame = (now: number): void => {
    frames += 1;
    longest = Math.max(longest, now - last);
    last = now;
    if (now - since >= 500) {
      box.textContent = `${Math.round((frames * 1000) / (now - since))} fps · longest ${Math.round(longest)} ms`;
      frames = 0;
      longest = 0;
      since = now;
    }
    requestAnimationFrame(frame);
  };
  requestAnimationFrame(frame);
}
